import { Box, Typography } from '@mui/material';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';

export const EmpowermentFinancingDashboard = () => {
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', minHeight: '600px' }}>
            <MDBox style={{ padding: '10px' }}>
                <MDTypography variant="h4" fontWeight="bold" style={{ paddingBottom: '15px' }}>
                    Dashboard - Empowerment Financing
                </MDTypography>
            </MDBox>
            <MDBox style={{ padding: '10px' }}>
                <Typography variant="body1">Coming soon.</Typography>
            </MDBox>
        </Box>
    );
};
